export const cities = [
  { value: "all", label: "All Cities" },
  { value: "Chicago", label: "Chicago" },
  { value: "Los Angeles", label: "Los Angeles" },
  { value: "New York", label: "New York" },
  { value: "Houston", label: "Houston" },
  { value: "Phoenix", label: "Phoenix" },
  { value: "Philadelphia", label: "Philadelphia" },
  { value: "San Antonio", label: "San Antonio" },
  { value: "San Diego", label: "San Diego" },
  { value: "Dallas", label: "Dallas" },
  { value: "Austin", label: "Austin" },
]

export const shopTypes = [
  { value: "all", label: "All Types" },
  // Order is the filter row's order: the barber-first types lead, Salon
  // closes the row.
  { value: "barbershop", label: "Barbershop" },
  { value: "studio", label: "Studio" },
  { value: "suite", label: "Suite" },
  { value: "salon", label: "Salon" },
]
